import CommonChart from './core/CommonChart';
import { Util } from './utils/Commom';
var F2 = require('@antv/f2');
export var Global = F2.Global;
export var Shape = F2.Shape;
export var Chart = F2.Chart;
export default function (config) {
    if (Util.isNil(config) || Util.isEmpty(config)) {
        return;
    }
    var commonChart = new CommonChart(config);
    commonChart.render();
    return commonChart;
}
//# sourceMappingURL=index.js.map